import 'magnific-popup';

export default function music() {

  $.magnificPopup.open( {
    items: {
      src: '#popup-info-laf',
      type: 'inline',
    }
  } );

  $('.block-music__content .link-buy > a').click(function(e){
    e.preventDefault();

    $(this).parent().toggleClass('open');
    $(this).parent().find('.links').slideToggle();
  });

  $('.block-music__content .item-image').mouseleave(function(){
    $(this).find('.link-buy').removeClass('open');
    $(this).find('.links').slideUp();
  });

  var sampler_link = $('.block-music .block-zox__title a');
 
  $(sampler_link).magnificPopup({
    type: 'iframe',
    closeOnContentClick: true,
    mainClass: 'mfp-img-mobile',
  });
  
  $('.popup-info-link').click(function(e){
    e.preventDefault();

    $.magnificPopup.open( {
      items: {
        src: $(this).attr('href'),
        type: 'inline',
      }
    } );
  });
}